export enum UserActionState {
  UNSTARTED = 0,
  ONGOING = 1,
  NOTIFICATION = 2,
  DONE = 3,
}
